import React, { forwardRef, useEffect, useLayoutEffect, useRef } from "react";
import "quill/dist/quill.snow.css";
import Quill from "quill";
import clsx from "clsx";

const RichTextEditor = forwardRef(({ readOnly, defaultValue, onTextChange = () => {}, label, error, helperText }, ref) => {
    const containerRef = useRef(null);
    const defaultValueRef = useRef(defaultValue);
    const onTextChangeRef = useRef(onTextChange);
    const hasError = Boolean(error);
    const hText = error || helperText;

    useLayoutEffect(() => {
        onTextChangeRef.current = onTextChange;
    });

    useEffect(() => {
        const container = containerRef.current;
        const editorContainer = container.appendChild(container.ownerDocument.createElement("div"));

        const quill = new Quill(editorContainer, {
            readOnly: readOnly,
            modules: {
                toolbar: readOnly
                    ? null
                    : [
                          [{ header: [1, 2, 3, 4, 5, 6, false] }],
                          ["bold", "italic", "underline", "strike"],
                          ["blockquote"],
                          ["link"],
                          [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                          [{ indent: "-1" }, { indent: "+1" }],
                          [{ align: [] }],
                          [{ color: [] }, { background: [] }],
                      ],
            },
            placeholder: readOnly ? undefined : "Your notes here...",
            theme: "snow",
        });

        if (readOnly) {
            quill.enable(false);
            quill.disable();
        }

        ref.current = quill;

        if (defaultValueRef.current) {
            quill.setContents(defaultValueRef.current);
        }

        quill.on(Quill.events.TEXT_CHANGE, (...args) => {
            if (quill.getText().trim().length > 0) {
                onTextChangeRef.current?.(quill.getContents().ops);
            } else {
                onTextChangeRef.current?.("");
            }
        });

        return () => {
            ref.current = null;
            container.innerHTML = "";
        };
    }, [ref, readOnly]);

    return (
        <div>
            {label && <label>{label}</label>}
            <div ref={containerRef}></div>
            {hText && <p className={clsx({ error: hasError, helperText: !hasError })}>{hText}</p>}
        </div>
    );
});

export default RichTextEditor;
